











































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Brand from '@/types/Brand.interface'
import models from '@/mixins/models-mixin'
import StockExchange from '@/types/StockExchange.interface'
import Input from '@/types/Input.interface'
export default Vue.extend({
    mixins: [models],
    data() {
        return {
            // The model we are updating
            model: null,
            //  Our proper named field map
            properMap: {
                city: 'City',
                company_name: 'Company Name',
                company_type: 'Company Type',
                company_status: 'Company Status',
                contact_email: 'Email',
                contact_name: 'Contact Name',
                contact_phone_number: 'Mobile Phone',
                country: 'Country',
                line1: 'Address Line 1',
                postal_code: 'Zip/Postal Code',
                tax_id: 'Tax Number/ID/EIN',
                vertical: 'Vertical Type',
                website: 'Website'
            },
            //  Our required fields
            required: [
                'city',
                'comapny_name',
                'company_type',
                'comapny_status',
                'contact_email',
                'contact_name',
                'contact_phone_number',
                'country',
                'line1',
                'postal_code',
                'tax_id',
                'vertical',
                'website'
            ],
            // The company status, determines if stock inputs are enabled
            status: null,
            // Tri-Panel toolbar
            toolbar: {
                title: '10DLC Registration',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            },
            // Determines if the error bar is shown
            errorBar: false,
            // Variables in the error bar
            errorVars: [],
            //  Boolean flag to determine if we are currently submitting
            submitting: false
        }
    },
    mounted() {
        // If the tenant is already registered, go back to info page
        if (this.brand) return this.$router.push('/brand-info')

        //  Else, initialize our brand
        this.model = this.newBrand()
    },
    computed: {
        ...mapGetters([
            'brand',
            'brandAddressInputs',
            'brandContactInputs',
            'stockExchanges',
            'tenant',
            'user'
        ]),
        brandCompanyInputs(): object {
            //  Stocks are enabled if the status of the company is public
            const stockEnabled = this.status === 'Public'

            // Get all the stock exchanges
            const exchanges = this.stockExchanges.map((x: StockExchange) => x.exchange)

            //  Grab our inputs function
            const inputs = this.$store.getters.brandCompanyInputs

            //  Retrieve the brand company inputs for this current brand
            return inputs(this.model, exchanges, !stockEnabled)
        },
        errorMessage(): string {
            return `Missing the following values: ${this.errorVars.join(', ')}`
        }
    },
    methods: {
        newBrand(): Brand {
            //  Return all of our new brand input fields
            return {
                company_type: null,
                company_status: null,
                company_name: null,
                dba: null,
                website: null,
                tax_id: null,
                alt_business_id_type: null,
                alt_business_id: null,
                alt_business_name: null,
                vertical: null,
                line1: null,
                line2: null,
                country: null,
                city: null,
                postal_code: null,
                state: null,
                region: null,
                stock_symbol: null,
                stock_exchange: null,
                contact_name: null,
                contact_email: null,
                contact_phone_number: null
            }
        },
        updateModel(input: Input, val: any): void {
            // If the input does not contain the method path, return.
            if (input?.path == null) return

            // If the company status (Private or Public) changes, update the status
            if (input.path === 'company_status') this.status = val

            //  Set the value at the path
            this.model[input.path] = val
        },
        async submit(): Promise<void> {
            //  Start the submitting flag
            this.submitting = true

            // Check if the model is valid
            const valid = this.validateSubmition(this.model)

            // If it is not valid do nothing
            if (!valid) {
                this.submitting = false
                return
            }

            // Attatch the tenant id to the request
            this.model.tenant_id = this.tenant.id

            // If the tenant's organization is public, ensure that they don't submit an invalid stock symbol and exchange
            if (this.model.company_status !== 'Public') {
                this.model.stock_symbol = null
                this.model.stock_exchange = null
            }

            // Convert country labels to short codes
            if (this.model.country === 'United States') this.model.country = 'US'
            else if (this.model.country === 'Canada') this.model.country = 'CA'

            // Attatch the tenant id to the request
            this.model.tenant_id = this.tenant.id

            // If the tenant's organization is public, ensure that they don't submit an invalid stock symbol and exchange
            if (this.model.company_status !== 'Public') {
                this.model.stock_symbol = null
                this.model.stock_exchange = null
            }

            // Convert country labels to short codes
            if (this.model.country === 'United States') this.model.country = 'US'
            else if (this.model.country === 'Canada') this.model.country = 'CA'

            // Else, send the delete request to the API
            const resp = await this.$store.dispatch('brandPost', this.model)

            //  Regardless of result, stop submitting flag
            this.submitting = false

            //  If the request failed, do nothing
            if (!resp) return

            //  Our intercom event metadata
            const metadata = {
                user_id: this.user.id,
                email: this.user.email,
                tenant_id: this.tenant.id
            }

            //  Report event to Intercom
            window.Intercom('trackEvent', 'a2pRegistrationSubmission', metadata)

            // Go back to brand-info route to see pending
            this.$router.push('/brand-info')
        },
        validateSubmition(model: Brand): boolean {
            // Container for missing fields
            const missingFields = []

            //  Create our clone that we want to validate fields on
            const vModel = window._.pick(model, this.required) as Brand

            //  Iterate through our vModel to see if fields are valid
            for (const [key, val] of Object.entries(vModel)) {
                //  If we have a value set, then continue
                if (val) continue

                //  Else, this field must be nullish so get the proper name of this field
                let proper = this.properMap[key]

                //  Add this to our missing fields
                missingFields.push(proper)
            }

            //  Check if the brand is in the united states
            const unitedStates =
                model.country === 'United States' || model.country === 'US'

            //  Check if a state was picked
            const missingState = !model.state || !model.state.length

            //  Check if the brand is in Canada
            const canada = model.country === 'Canada' || model.country === 'CA'

            //  Check if a region is missing
            const missingRegion = !model.region || !model.region.length

            //  If the user is in the united states but has NOT picked a state, add state to missing fields
            if (unitedStates && missingState) missingFields.push('State')
            //  Else if the user is in Canada but didn't pick a region, add region to missing fields
            else if (canada && missingRegion) missingFields.push('Region/Province')

            //  If there are NOT missing fields then just hide our warning and return
            if (!missingFields.length) {
                this.errorBar = false
                return true
            }

            // If there are missing fields, display the warning
            this.errorVars = [...missingFields]
            this.errorBar = true
            return false
        }
    },
    watch: {
        // If the brand loads go back to the info page
        brand(): void {
            if (this.brand) this.$router.push('/brand-info')
        }
    }
})
